import React, { useRef, useState, useEffect } from 'react';
import { useFilesConfig } from '../data/filesconfig-hooks';
import File from './File';
import FileDetail from './FileDetail';
import { Upload } from '@progress/kendo-react-upload';

function Files(props) {
    const listRef = useRef(null);
    const { filesConfig, getDetails, setFileList } = useFilesConfig();
    const [files, setFiles] = useState([]);
    const [isActiveOnly, setIsActiveOnly] = useState(true);

    const onAdd = (event) => {
        setFiles(event.newState);
    };

    const onRemove = (event) => {
        setFiles(event.newState);
    };

    const onStatusChange = (event) => {
        const updatedFiles = event.newState.filter(file => file.status !== 4); // 4 is the status for uploaded files
        setFiles(updatedFiles);
    };

    useEffect(() => {
    
        async function fetchData() {
            const response = await fetch(filesConfig.RefreshUrl);
            const jsonData = await response.json();
            
            setFileList(jsonData);
        }

        fetchData();
    }, [files]);

    const isActiveCheckbox = document.getElementById(filesConfig.ActiveCheckboxID);
    if (typeof (isActiveCheckbox) !== "undefined" && isActiveCheckbox != null) {
        isActiveCheckbox.onclick = async function (ev) {
            setIsActiveOnly(isActiveCheckbox.checked);
        };
    }

    const details = getDetails().filter(function (user) {
        return isActiveOnly === false || user.IsActive === true;
    });

    const visible = filesConfig.DetailDialogVisible;
    const imagePreview = filesConfig.ShowThumbnail ? <th>&nbsp;</th> : null;
    const dimensions = filesConfig.ShowDimensions ? <th>[![Dimensions]!]</th> : null;
    const columnCount = filesConfig.ShowThumbnail ? (filesConfig.ShowDimensions ? 11 : 10) : (filesConfig.ShowDimensions ? 10 : 9);
    const allowedExtensions = filesConfig.AllowedExtensions.split(',');

    return (
        <div> 
            {visible && (
                <FileDetail></FileDetail>
            )}

            <table className="datagrid" ref={listRef}>
                <thead>
                    <tr className="datagridheader">
                        <th>&nbsp;</th>
                        {imagePreview}
                        <th>[![Title]!]</th>
                        <th>[![Caption]!]</th>
                        <th>[![Type]!]</th>
                        {dimensions}
                        <th>[![Size]!]</th>
                        <th>[![Created By]!]</th>
                        <th>[![Created Date]!]</th>
                        <th>[![Active]!]</th>
                        <td>
                            &nbsp;
                        </td>
                    </tr>
                </thead>
                <tbody>
                    {details.map((dt) => {
                        return (
                            <File key={dt.AccountFileID} Id={dt.AccountFileID}></File>
                        );
                    })}
                </tbody>
                <tfoot>
                    <tr className='datagridfooter'>
                        <td colSpan={columnCount} style={{textAlign: 'right'}}>
                        <Upload
                            batch={false}
                            multiple={true}
                            accept={filesConfig.AcceptMimeType}
                            files={files}
                            onAdd={onAdd}
                            onRemove={onRemove}
                            onStatusChange={onStatusChange}
                            saveUrl={filesConfig.UploadUrl}
                            restrictions={{
                                allowedExtensions: allowedExtensions
                            }}
                            />
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    );
}

export default Files;